export default function App() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-bg px-6 text-center">
      <div className="max-w-xl">
        <h1 className="font-display text-5xl font-bold text-primary md:text-6xl">SupplySage</h1>
        <p className="mt-4 text-xl text-text-muted">AI Coordinator for independent lumber yards.</p>
        <p className="mt-8 inline-block rounded-full bg-accent px-6 py-2 text-sm font-semibold uppercase tracking-wider text-white">
          Coming soon
        </p>
      </div>
    </main>
  );
}
